/*
 * @Author: yzr
 * @Date: 2020-11-26 16:29:20
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-26 16:29:21
 */
import NoticeManageTableForm from './table_form.vue';

export default NoticeManageTableForm;
